<template>
  <div class="login">
    <div class="log-top">
      <div class="top">
        <div class="left">
          <img
            style="height: 55px"
            src="../../assets/images/logo.png"
            alt="山河医学网logo"
          />
          <h1>欢迎登录</h1>
        </div>
        <div class="right">
          <ul>
            <li><RouterLink target="_blank" to="/">首页</RouterLink></li>
            <li>
              <RouterLink target="_blank" to="/news">考情资讯</RouterLink>
            </li>
            <li>
              <RouterLink target="_blank" to="/video">课程体验</RouterLink>
            </li>
            <li>
              <RouterLink target="_blank" to="/tests">题库体验</RouterLink>
            </li>
          </ul>
        </div>
      </div>

      <div class="box">
        <div class="log-way" v-show="activeName === 'weixin'">
          <WeiLogin @changePwd="changePwd" @changeCode="changeCode" />
        </div>
        <div class="log-way" v-show="activeName === 'phone'">
          <PhoneLogin @changeWei="changeWei" ref="childRef" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import PhoneLogin from "./components/sh-phonelogin.vue";
import WeiLogin from "./components/sh-weilogin.vue";
export default {
  components: { PhoneLogin, WeiLogin },
  setup() {
    const childRef = ref();
    const activeName = ref("weixin");
    const changePwd = () => {
      try {
        activeName.value = "phone";
        /* weilogin.value = !weilogin.value;*/
        childRef.value.weiToPwd();
      } catch (error) {
        console.log(error);
      }
    };
    const changeCode = () => {
      try {
        activeName.value = "phone";
        /* weilogin.value = !weilogin.value;*/
        childRef.value.weiToCode();
      } catch (error) {
        console.log(error);
      }
    };
    //从账号密码和验证码登录切换到微信登录
    const changeWei = () => {
      try {
        activeName.value = "weixin";
      } catch (error) {
        console.log(error);
      }
    };
    return { activeName, changeWei, changePwd, changeCode, childRef };
  },
};
</script>

<style lang="less" scoped>
.login {
  //width: 1920px;
  min-height: 580px;
  position: relative;
  .log-top {
    width: 100%;
    height: 72px;
    background: #fefefe;

    .top {
      display: flex;
      justify-content: space-between;
      width: 1240px;
      height: 72px;
      margin: 0 auto;

      .left {
        display: flex;
        height: 72px;
        align-items: center;
        h1 {
          margin-left: 25px;
        }
      }
      .right {
        width: 425px;
        height: 72px;
        ul {
          height: 72px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          a {
            font-size: 18px;

            &:hover {
              color: @shColor;
              border-bottom: 1px solid;
            }
          }
        }
      }
    }
    .box {
      position: absolute;
      width: 430px;
      min-height: 480px;
      top: 95px;
      right: 25%;
      background: #fefefe;
      border-radius: 20px;
      .log-way {
        margin-top: 18px;
        width: 350px;
        height: 30px;
        margin: 20px auto;
      }
    }
  }
}
</style>
